import React from 'react';
import estilos from '../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
const MovimientosEnvasadoraComponent = ({ envasadora }) => {
    const ingresos = envasadora.find((item) => item.ingreso)?.ingreso || [];
    const altas = envasadora.find((item) => item.alta)?.alta || [];
    const movimientos = envasadora.find((item) => item.movimientos)?.movimientos || [];
    const traslados = envasadora.find((item) => item.traslados)?.traslados || [];
    const envasados = envasadora.find((item) => item.envasados)?.envasados || [];
    const instalacion = envasadora.find((item) => item.instalacion)?.instalacion || '';
    const recepcionTR = envasadora.find((item) => item.recepcionTR)?.recepcionTR || [];
    console.log(envasadora)
    return (
        <div className="container mt-4">
            {/* Ingresos */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Ingresos</h5>
                    {ingresos.map((ingreso, index) => (
                        <p key={index} className="card-text">
                            <strong>Lote Envasadora: </strong>{ingreso.loteEnvasadora}
                            <br />
                            <strong>Litros: </strong>{ingreso.litros} - <strong>Grado: </strong>{ingreso.grado} - <strong>Fecha: </strong>{ingreso.fecha}
                            <br />
                            <strong>Inspector: </strong>{ingreso.inspector}
                        </p>
                    ))}
                </div>
            </div>

            {/* Altas */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Altas</h5>
                    {altas.map((alta, index) => (
                        <p key={index} className="card-text">
                            <strong>Lote Envasadora: </strong>{alta.loteEnvasadora}
                            <br />
                            <strong>Litros: </strong>{alta.litros} - <strong>Grado: </strong>{alta.grado} - <strong>Fecha: </strong>{alta.fecha}
                            <br />
                            <strong>Inspector: </strong>{alta.inspector}
                        </p>
                    ))}
                </div>
            </div>

            {/* Movimientos */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Movimientos</h5>
                    {movimientos.map((movimiento, index) => (
                        <div key={index} className="card mb-2">
                            <div className="card-body">
                                <p className="card-text">
                                    <strong>Lote Granel: </strong>{movimiento.loteGranel}
                                    <br />
                                    <strong>Folio: </strong>{movimiento.folio} - <strong>Litros: </strong>{movimiento.litros} - <strong>Grado: </strong>{movimiento.grado}
                                    <br />
                                    <strong>Fecha: </strong>{movimiento.fecha}
                                    <br />
                                    <strong>Inspector: </strong>{movimiento.inspector}
                                    <br />
                                    <strong>Descripción: </strong>{movimiento.descripcion}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Traslados */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Traslados</h5>
                    {traslados.map((traslado, index) => (
                        <p key={index} className="card-text">
                            <strong>Lote: </strong>{traslado.lote}
                            <br />
                            {`Salida: ${traslado.clienteSalida} (${traslado.instalacionSalida}) - Destino: ${traslado.clienteDestino} (${traslado.instalacionDestino}) - Fecha: ${traslado.fecha} - Litros: ${traslado.litros}`}
                        </p>
                    ))}
                </div>
            </div>

            {/* Envasados */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Envasados</h5>
                    {envasados.map((envasado, index) => (
                        <p key={index} className="card-text">
                            <strong>Lote: </strong>{envasado.lote}
                            <br />
                            <strong>Cliente Solicita: </strong>{envasado.clienteSolicita} - <strong>Fecha: </strong>{envasado.fecha} - <strong>Botellas: </strong>{envasado.botellas} - <strong>Litros: </strong>{envasado.litros}
                            <br />
                            <strong>Inspector: </strong>{envasado.inspector}
                        </p>
                    ))}
                </div>
            </div>

            {/* Instalación */}
            {/* <div className="card mb-3">
                <div className="card-body">
                    <h5 className="card-title">Instalación</h5>
                    <p className="card-text">
                        <strong>Nombre: </strong>{instalacion.instalacion}
                        <br />
                        <strong>Litros: </strong>{instalacion.litros}
                    </p>
                </div>
            </div> */}

            {/* Recepción de Traslados */}
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className={`card-title ${estilos.labelUI} mb-2`}>Recepción de Traslados</h5>
                    {recepcionTR.map((recepcion, index) => (
                        <p key={index} className="card-text">
                            <strong>Lote: </strong>{recepcion.lote}
                            <br />
                            {`Salida: ${recepcion.clienteSalida} (${recepcion.instalacionSalida}) - Destino: ${recepcion.clienteDestino} (${recepcion.instalacionDestino}) - Fecha: ${recepcion.fecha} - Litros: ${recepcion.litros}`}
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MovimientosEnvasadoraComponent;
